export default __webpack_public_path__ + "367c0e0aa30e866a0c0ca94e0efdcefe.png";